import {http as httpApiGateway} from "./api/restApiClient";

/**
 * Template API service — routes template requests through the REST API Gateway
 * to the template_api Lambda.
 */
export const DocumentService = {
  getTemplateNames: () => httpApiGateway.get("/templates"),

  getTemplate: (templateId: string, workflowType?: string) =>
    httpApiGateway.get(
      `/templates/${templateId}/template${workflowType ? `?workflow_type=${encodeURIComponent(workflowType)}` : ""}`,
    ),

  getLatestTemplateVersion: (facilityId: string) =>
    httpApiGateway.get(`/templates/facility/${facilityId}/current`),

  getTemplateVersion: (facilityId: string, versionId: string) =>
    httpApiGateway.get(`/templates/facility/${facilityId}/versions/${versionId}`),

  getPreflightTemplate: (templateId: string, workflowType?: string) =>
    httpApiGateway.get(
      `/templates/${templateId}/preflight${workflowType ? `?workflow_type=${encodeURIComponent(workflowType)}` : ""}`,
    ),

  getFacilitySettingsTemplate: (templateId: string, workflowType?: string) =>
    httpApiGateway.get(
      `/templates/${templateId}/facility-settings${
        workflowType
          ? `?workflow_type=${encodeURIComponent(workflowType)}`
          : ""
      }`,
    ),

  getPreludeExperienceTemplate: (templateId: string, workflowType?: string) =>
    httpApiGateway.get(
      `/templates/${templateId}/prelude${workflowType ? `?workflow_type=${encodeURIComponent(workflowType)}` : ""}`,
    ),
};
